//
// Module for the Direct Deposit Index view
//
rs.module("content/participant/benefit/directdeposit/index",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, ajaxUrl) {

            var filter = $.js(jsSelectors.filter);

            var addButton = $.js(jsSelectors.addButton);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            filter.js(jsSelectors.directDepositAsOfDate).find("input").on('click', function () {

                filter.js(jsSelectors.loadingSpinner).show();

                gridModule.update(

                    ajaxUrl,
                    { showAllDirectDeposits: this.value },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) {
                        filter.js(jsSelectors.loadingSpinner).hide();

                        // Update the Add button url to include the current selection
                        addButton.attr('href', gridUpdate.context.addUrl);
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);